export type ThemeId = 'light' | 'dark';

export const THEME_STORAGE_KEY = 'detrix-theme';

export function applyThemeToDocument(theme: ThemeId): void {
  document.documentElement.dataset.theme = theme;
  document.documentElement.style.colorScheme = theme === 'light' ? 'light' : 'dark';
}

export function readStoredTheme(): ThemeId | null {
  if (typeof window === 'undefined') return null;
  try {
    const v = window.localStorage.getItem(THEME_STORAGE_KEY);
    if (v === 'light' || v === 'dark') return v;
  } catch {
    /* */
  }
  return null;
}

export function preferredSystemTheme(): ThemeId {
  if (typeof window === 'undefined') return 'dark';
  return window.matchMedia('(prefers-color-scheme: light)').matches ? 'light' : 'dark';
}

export function resolveTheme(): ThemeId {
  return readStoredTheme() ?? preferredSystemTheme();
}

export function themeFromDocument(): ThemeId {
  const t = document.documentElement.dataset.theme;
  return t === 'light' ? 'light' : 'dark';
}
